module.exports = __webpack_public_path__ + "static/img/cmef-wx.39cdcae8.png";